import React, { useState, useEffect } from 'react';
import { useErrorContext } from '../../components/messages/ErrorBox';
import { usePageLoadingContext } from '../../components/messages/PageLoading';
import { useLocale } from '../../components/special/LanguageProvider';
import { apiGetCall, apiPostCall, apiDeleteCall, apiPutCall, isResultOk } from '../../components/special/apiCall';
import EditFormFieldTable from 'components/form/EditFormFieldTable';
import InputDropDownList from '../../components/input/InputDropDownList';
import RowButtons from '../../components/button/RowButtons';
import RowChangeButton from '../../components/button/RowChangeButton';
import RowDeleteButton from '../../components/button/RowDeleteButton';
import RowAddButton from '../../components/button/RowAddButton';
import ButtonSave from '../../components/button/ButtonSave';
import ListTable from '../../components/form/ListTable';
import Button from 'shared/jsx/elements/buttons/Button';


const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const ActionDiaryTextList = ({ }) => {
  const [actList, setActList] = useState([]);
  const [textList, setTextList] = useState([]);

  const [listLoading, setListLoading] = useState(false);

  const [textEdit, setTextEdit] = useState( null );
  const [dataList, setDataList] = useState({textList: [], originalList: []});
  

  const setCheckErrorItems = useErrorContext();
  const [listError, setListError] = useState(null);
  const setIsPageLoading = usePageLoadingContext();
  const { t } = useLocale();

  const [workingData, setWorkingData] = useState({
    actionID: null
  });

  const loadActionList = async () => {
    const data = await apiGetCall(BASE_URL + '/admin/list/action/actiontext/diary/allowed');
if (isResultOk(data, setListError, true)) {
  setActList(data);
    }
    setListLoading(false);
  }

  useEffect(() => {
    loadActionList();
  }, []);

 
  const onBackClick = () => {

  }

  const validateInput = async () => {

    return true;
  }

  const onSaveClick = async () => {

    setIsPageLoading(true);



    setIsPageLoading(false);
  }

  const editPressed = async(item) => {
    setTextEdit( item );
  }

  const addRow = async() => {
    setListLoading(true);
    setTextList([...textList, {itemID: 0, name: "Nýr texti"}]);
    setListLoading(false);
  }

  const itemSelected = async(item) => {
    setWorkingData({ ...workingData, actionID: item });
    setTextEdit( null );
   
    loadTextList(item);
  }

  const loadTextList = async(actionID) => {
    const data = await apiGetCall(BASE_URL + '/admin/actiontexts/diary/' + actionID);
    
     if (isResultOk(data, setListError, true)){
     
      setTextList(data);
     }else {
      setTextEdit([]);
     }
  }

  const cancelChange = async() => {
    setListLoading(true);
    loadTextList(workingData.actionID);
    setTextEdit(null);
    setListLoading(false);
  }

  const deleteActionText = async(item) => {
    setListLoading(true);
    let requestResult = await apiDeleteCall(BASE_URL + '/admin/actiontext/diary/' + item);
    if (isResultOk(requestResult, setCheckErrorItems)){
      await loadTextList(workingData.actionID);
    }
    setListLoading(false);
  }

  function updateText(text, id) {
   
    const temp = [...textList];
    (temp.find(it => it.itemID == id)).name = text;
    setTextList(temp );
  }

  

  const saveActionText = async(item) => {
    setListLoading(true);
    let apiRequestResult = null;
    let textData = { actionID: workingData.actionID, actionTextID: item.itemID, actionText: item.name};
    if(item.itemID == 0){
      apiRequestResult = await apiPostCall(BASE_URL + '/admin/actiontexts/diary/${item.itemID}/', textData);
    }else {
      apiRequestResult = await apiPutCall(BASE_URL + '/admin/actiontexts/diary/${item.itemID}/', textData);
    }
    if (isResultOk(apiRequestResult, setCheckErrorItems)){
      await loadTextList(workingData.actionID);
      setTextEdit(null);
    }
    setListLoading(false);
  }


  return (
    <div>
      <div>
        <h1>Textar dagatal</h1>
      </div>
      <div>
        <EditFormFieldTable fields={[
          {
            title: "Aðgerðir",
            edit: () => <InputDropDownList
              name="ActionID"
              disabled={false}
              list={actList}
              keyField="itemID"
              displayField={(item) => { return item.name }}
              defaultValue={workingData.actionID}
              onChange={(value) => itemSelected(value)}
              nullable={true}
              nullableItem={{ itemID: null, name: "Velja aðgerð" }}
            />
          },
        ]} />
        <div className="text-center"><h3>Textar</h3></div>
        <div className="text-right text-semibold" style={{ display: ( workingData.actionID == null || textList.length > 0) ? 'none' : 'block' } }>
         <span>Bæta við texta skilgreiningu </span><RowAddButton onClick={()=> addRow()}/></div> 
     

        <ListTable 
              error={null}
              isLoading={listLoading}
              list={textList}
              colsettings={['80%','20%']}
              headers={[
                t("Texti"),
                ""
              ]}
              columns={[
                (item) =>  <textarea
                onChange={e => updateText(e.target.value, item.itemID)}
                style={{ minWidth: 850, wordWrap: true }}
                value={item.name}
                disabled={textEdit != item.itemID}
              />,
                (item) =>  
                (<div><div style={{ display: ( textEdit == item.itemID) ? 'none' : 'block' } }>
                  <RowButtons>
                  <RowChangeButton onClick={() => editPressed(item.itemID)} />
                  <RowDeleteButton onClick={() => deleteActionText(item.itemID)}/>
              </RowButtons></div>
              <div style={{ display: ( textEdit != item.itemID) ? 'none' : 'block' } }>
              <RowButtons>
              <ButtonSave onClick={() => saveActionText(item)}/>
              <Button tooltip={t("Hætta við")} text="Hætta við" iconclass={"icon-blocked no-text"} onClick={() => cancelChange()} />
          </RowButtons></div></div>),
              ]}
            />
      </div>
     
    </div>
  );
};

